import { render, staticRenderFns } from "./sysdetail.vue?vue&type=template&id=69ff3aea&scoped=true"
import script from "./sysdetail.vue?vue&type=script&lang=js"
export * from "./sysdetail.vue?vue&type=script&lang=js"
import style0 from "./sysdetail.vue?vue&type=style&index=0&id=69ff3aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ff3aea",
  null
  
)

export default component.exports